module.exports = __webpack_public_path__ + "img/Villa_Borna_10.fb09022d.jpg";